import {
  setupHeaderResizeObserver,
  HeaderResizedEvent,
  headerResizedEventKey,
} from "@utils/typescript/custom-events/header-resized.ts";

document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector("header");
  const container =
    document.querySelector<HTMLElement>("body > .page-body.body-bg-darkgrey") ??
    document.querySelector<HTMLElement>("body > .container");
  const main = container?.querySelector("main");

  if (!header || !container || !main) return;

  const announcementBar =
    header.querySelector<HTMLDivElement>(".announcement-bar");

  if (!document.querySelector("header.head-dynamic")) {
    setupHeaderResizeObserver();
    updatePaddingTop(container, header.offsetHeight);
    header.addEventListener(headerResizedEventKey, (event) =>
      onHeaderUpdateHeight(event as CustomEvent<HeaderResizedEvent>, container),
    );
  }

  if (announcementBar) {
    const closeButton = document.querySelector(
      ".announcement-bar__close button",
    );

    if (!closeButton) {
      throw new Error("Announcement bar has no close button");
    }

    closeButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      announcementBar.style.display = "none";
      const expireTime = new Date(Date.now() + 1000 * 24000);
      document.cookie = `ad_seen=true;expires=${expireTime.toUTCString()};path=/;secure;`;
    });
  }
});

function updatePaddingTop(targetElement: HTMLElement, paddingTopValue: number) {
  targetElement.style.paddingTop = `${paddingTopValue}px`;
}

function onHeaderUpdateHeight(event: CustomEvent, targetElement: HTMLElement) {
  const detail = event.detail;
  updatePaddingTop(targetElement, detail.height);
}
